import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface SitelinkModel extends BaseModel {
  variables?: { [key: string]: string } | SitelinkVariables;
}

export interface SitelinkVariables {
  Text: string;
  FirstDescriptionLine: string;
  SecondDescriptionLine: string;
  SitelinkLink: string;
}

export class SitelinkInitVariables implements SitelinkVariables {
  Text = '';
  FirstDescriptionLine = '';
  SecondDescriptionLine = '';
  SitelinkLink = '';
}

export class SitelinkInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new SitelinkInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
